<template>
  <loading v-if="loadingStatus" />
  <div v-else>
    <div class="general-data-wrapper">
      <div class="general-data__content-wrapper">
        <span>CNPJ</span>
        <input
          type="text"
          :value="generalData.cnpj"
          disabled
        >
      </div>
      <div class="general-data__content-wrapper">
        <span>Razão Social</span>
        <input
          type="text"
          :value="generalData.businessName"
          disabled
        >
      </div>
      <div class="general-data__content-wrapper">
        <span>Nome Fantasia</span>
        <p>
          <input
            v-if="editingFields.fantasyName"
            v-model="generalData.fantasyName"
          >
          <input
            v-else
            :value="generalData.fantasyName"
            disabled
          >
          <button
            v-if="!editingFields.fantasyName && toggle.generalData"
            class="invisible"
            @click="editField('fantasyName')"
          >
            <svg-loader
              class="edit"
              src="/static/images/dados-gerais/edit.svg"
            />
          </button>
          <button
            v-if="editingFields.fantasyName"
            class="invisible"
            @click="saveField('fantasyName')"
          >
            <svg-loader
              class="check"
              src="/static/images/check-dropdown.svg"
            />
          </button>
        </p>
      </div>
    </div>
    <div class="general-data-wrapper">
      <div class="general-data__content-wrapper">
        <span>País</span>
        <input
          :value="generalData.addresses[0].country"
          disabled
        >
      </div>
      <div class="general-data__content-wrapper">
        <span>CEP</span>
        <div>
          <p>
            <input
              v-if="editingFields.cep"
              v-model="generalData.addresses[0].cep"
              @input="validateInput('cep')"
            >
            <input
              v-else
              :value="generalData.addresses[0].cep"
              disabled
            >
            <button
              v-if="!editingFields.cep && toggle.generalData"
              class="invisible"
              @click="editField('cep')"
            >
              <svg-loader
                class="edit"
                src="/static/images/dados-gerais/edit.svg"
              />
            </button>
            <button
              v-if="editingFields.cep"
              class="invisible"
              @click="saveField('cep')"
            >
              <svg-loader
                class="check"
                src="/static/images/check-dropdown.svg"
              />
            </button>
          </p>
          <span
            v-if="errors.cep"
            class="error"
          >{{ errors.cep }}</span>
        </div>
      </div>
      <div class="general-data__content-wrapper">
        <span>UF e Cidade</span>
        <div>
          <p style="display: flex; gap: 8px">
            <select
              v-if="editingFields.uf || editingFields.city"
              v-model="selectedUF"
              @change="fetchCities(); validateInput('uf')"
            >
              <option
                v-for="uf in ufList.options"
                :key="uf.value"
                :value="uf.value"
              >
                {{ uf.label }}
              </option>
            </select>
            <input
              v-else
              :value="generalData.addresses[0].city ? generalData.addresses[0].city.uf : ''"
              disabled
            >
            <select
              v-if="editingFields.city || editingFields.uf"
              v-model="selectedCity"
              :disabled="loadingCities || !cityList.length"
              @change="validateInput('city')"
            >
              <option
                value=""
                disabled
                selected
              >
                Selecione...
              </option>
              <option
                v-for="city in cityList"
                :key="city.id"
                :value="city"
              >
                {{ city.name }}
              </option>
            </select>

            <input
              v-else
              :value="generalData.addresses[0].city.name"
              disabled
            >
            <button
              v-if="!editingFields.uf && toggle.generalData"
              class="invisible"
              @click="editField('uf', 'city')"
            >
              <svg-loader
                class="edit"
                src="/static/images/dados-gerais/edit.svg"
              />
            </button>
            <button
              v-if="editingFields.uf || editingFields.city"
              class="invisible"
              @click="saveField('uf', 'city')"
            >
              <svg-loader
                class="check"
                src="/static/images/check-dropdown.svg"
              />
            </button>
          </p>
          <span
            v-if="errors.uf || errors.city"
            class="error"
          >
            {{ errors.uf || errors.city }}
          </span>
        </div>
      </div>
      <div class="general-data__content-wrapper">
        <span>Bairro</span>
        <div>
          <p>
            <input
              v-if="editingFields.neighborhood"
              v-model="generalData.addresses[0].neighborhood"
              @input="validateInput('neighborhood')"
            >
            <input
              v-else
              :value="generalData.addresses[0].neighborhood"
              disabled
            >
            <button
              v-if="!editingFields.neighborhood && toggle.generalData"
              class="invisible"
              @click="editField('neighborhood')"
            >
              <svg-loader
                class="edit"
                src="/static/images/dados-gerais/edit.svg"
              />
            </button>
            <button
              v-if="editingFields.neighborhood"
              class="invisible"
              @click="saveField('neighborhood')"
            >
              <svg-loader
                class="check"
                src="/static/images/check-dropdown.svg"
              />
            </button>
          </p>
          <span
            v-if="errors.neighborhood"
            class="error"
          >{{ errors.neighborhood }}</span>
        </div>
      </div>
      <div class="general-data__content-wrapper">
        <span>Rua</span>
        <div>
          <p>
            <input
              v-if="editingFields.street"
              v-model="generalData.addresses[0].street"
              @input="validateInput('street')"
            >
            <input
              v-else
              :value="generalData.addresses[0].street"
              disabled
            >
            <button
              v-if="!editingFields.street && toggle.generalData"
              class="invisible"
              @click="editField('street')"
            >
              <svg-loader
                class="edit"
                src="/static/images/dados-gerais/edit.svg"
              />
            </button>
            <button
              v-if="editingFields.street"
              class="invisible"
              @click="saveField('street')"
            >
              <svg-loader
                class="check"
                src="/static/images/check-dropdown.svg"
              />
            </button>
          </p>
          <span
            v-if="errors.street"
            class="error"
          >{{ errors.street }}</span>
        </div>
      </div>
      <div class="general-data__content-wrapper">
        <span>Número</span>
        <div>
          <p>
            <input
              v-if="editingFields.number"
              v-model="generalData.addresses[0].number"
              @input="validateInput('number')"
            >
            <input
              v-else
              :value="generalData.addresses[0].number"
              disabled
            >
            <button
              v-if="!editingFields.number && toggle.generalData"
              class="invisible"
              @click="editField('number')"
            >
              <svg-loader
                class="edit"
                src="/static/images/dados-gerais/edit.svg"
              />
            </button>
            <button
              v-if="editingFields.number"
              class="invisible"
              @click="saveField('number')"
            >
              <svg-loader
                class="check"
                src="/static/images/check-dropdown.svg"
              />
            </button>
          </p>
          <span
            v-if="errors.number"
            class="error"
          >{{ errors.number }}</span>
        </div>
      </div>
      <div class="general-data__content-wrapper">
        <span>Complemento</span>
        <p>
          <input
            v-if="editingFields.complement"
            v-model="generalData.addresses[0].complement"
          >
          <input
            v-else
            :value="generalData.addresses[0].complement"
            disabled
          >
          <button
            v-if="!editingFields.complement && toggle.generalData"
            class="invisible"
            @click="editField('complement')"
          >
            <svg-loader
              class="edit"
              src="/static/images/dados-gerais/edit.svg"
            />
          </button>
          <button
            v-if="editingFields.complement"
            class="invisible"
            @click="saveField('complement')"
          >
            <svg-loader
              class="check"
              src="/static/images/check-dropdown.svg"
            />
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import generalDataService from '@/api/generalData'
import notify from '@/api/notification'
import strings from '../../../strings'

export default {
  data() {
    return {
      loadingStatus: false,
      ufList: {
        id: 'uf-select',
        label: 'Selecione a UF:',
        placeholder: 'Selecione a UF',
        options: strings.brazilStates
      },
      selectedUF: '',
      cityList: [],
      loadingCities: false,
      generalData: null,
      errors: {
        cep: '',
        uf: '',
        city: '',
        neighborhood: '',
        street: '',
        number: ''
      },
      editingFields: {
        fantasyName: false,
        country: false,
        cep: false,
        uf: false,
        neighborhood: false,
        city: false,
        street: false,
        number: false,
        complement: false
      }
    }
  },
  computed: {
    ...mapGetters(['profile', 'toggle'])
  },
  mounted() {
    this.getGeneralData()
  },
  methods: {
    validateInput(field) {
      this.errors[field] = ''

      if (field === 'cep' && !this.generalData.addresses[0].cep) {
        this.errors.cep = 'Campo obrigatório'
      }

      if (field === 'uf' && !this.selectedUF) {
        this.errors.uf = 'Campo obrigatório'
      }

      if (field === 'city' && !this.selectedCity) {
        this.errors.city = 'Campo obrigatório'
      }

      if (field === 'neighborhood' && !this.generalData.addresses[0].neighborhood) {
        this.errors.neighborhood = 'Campo obrigatório'
      }

      if (field === 'street' && !this.generalData.addresses[0].street) {
        this.errors.street = 'Campo obrigatório'
      }

      if (field === 'number' && !this.generalData.addresses[0].number) {
        this.errors.number = 'Campo obrigatório'
      }
    },
    fetchCities() {
      this.cityList = []
      this.loadingCities = true
      generalDataService
        .getCities(this.selectedUF)
        .then(response => {
          this.cityList = response.data.map(city => ({
            id: city.id,
            name: city.name,
            laborId: city.laborId
          }))
          this.loadingCities = false
          this.selectedCity = ''
        })
        .catch(() => {
          this.loadingCities = false
        })
    },
    editField(...fields) {
      fields.forEach(field => {
        this.$set(this.editingFields, field, true)
      })

      this.selectedUF = this.generalData.addresses[0].city.uf
      this.selectedCity = this.generalData.addresses[0].city
    },
    validateRequiredFields(fields) {
      fields.forEach((field) => {
        this.errors[field] = ''
      })

      let hasError = false

      if (fields.includes('cep') && !this.generalData.addresses[0].cep) {
        this.errors.cep = 'Campo obrigatório'
        hasError = true
      }
      if (fields.includes('uf') && !this.selectedUF) {
        this.errors.uf = 'Campo obrigatório'
        hasError = true
      }
      if (fields.includes('city') && !this.selectedCity) {
        this.errors.city = 'Campo obrigatório'
        hasError = true
      }
      if (fields.includes('neighborhood') && !this.generalData.addresses[0].neighborhood) {
        this.errors.neighborhood = 'Campo obrigatório'
        hasError = true
      }
      if (fields.includes('street') && !this.generalData.addresses[0].street) {
        this.errors.street = 'Campo obrigatório'
        hasError = true
      }
      if (fields.includes('number') && !this.generalData.addresses[0].number) {
        this.errors.number = 'Campo obrigatório'
        hasError = true
      }

      return !hasError
    },
    saveField(...fields) {
      const isValid = this.validateRequiredFields(fields)
      if (!isValid) {
        return
      }

      this.generalData.addresses[0].city = this.selectedCity

      fields.forEach(field => {
        this.$set(this.editingFields, field, false)
      })

      this.updateGeneralData()
    },
    getGeneralData() {
      this.loadingStatus = true
      generalDataService
        .getGeneralData()
        .then(res => {
          this.loadingStatus = false
          this.generalData = res.data
          if (this.generalData.addresses && this.generalData.addresses[0]) {
            const address = this.generalData.addresses[0]
            address.city = address.city || { name: '', uf: '', county: '' }
            address.neighborhood = address.neighborhood || ''
            address.street = address.street || ''
            address.complement = address.complement || ''
            address.country = 'BR'
          } else {
            this.generalData.addresses = [
              {
                city: { name: '', uf: '', county: '' },
                neighborhood: '',
                street: '',
                complement: '',
                country: 'BR'
              },
            ]
          }
          this.selectedUF = this.generalData.addresses[0].city.uf || ''
          this.selectedCity = this.generalData.addresses[0].city || ''
          this.validateRequiredFields([
            'cep',
            'uf',
            'city',
            'neighborhood',
            'street',
            'number'
          ])
        })
        .catch(() => {
          this.loadingStatus = false
        })
    },
    updateGeneralData() {
      this.loadingStatus = true
      generalDataService
        .updateGeneralData(this.generalData)
        .then(res => {
          this.loadingStatus = false
          this.generalData = res.data
          notify({
            title: 'AVISO:',
            message: 'Dados gerais atualizados com sucesso.'
          })
        })
        .catch(err => {
          this.loadingStatus = false
          notify({
            title: 'AVISO:',
            message: 'Erro ao atualizar os dados gerais.'
          })
          console.error('General Data Endpoint --->', err)
        })
    },
  },
}
</script>

<style lang="scss">
	.general-data-wrapper {
		background-color: #fff;
		border: 4px #fff solid;
		border-radius: 6px;
		padding: 4px;
		margin-bottom: 16px;
	}

</style>